import * as actions from '../../actions/actiontypes';
import initialstate from '../initialstate';
import Utility from '../../util/utilityfunctions';

export default function fourFortyGlDocumentsReducer(state = initialstate.fourFortyGlDocuments, action) {
	let newState;

	switch (action.type) {
		// doc download --> Add the current document to the list
		case actions.DOCHELPER_DOWNLOAD_DOCUMENT: {
			if (action.meta && action.meta.docHelper && action.meta.docHelper.payload) {
				const payload = action.meta.docHelper.payload;
				let documents = initializeDocuments(state);

				documents = {
					byId: {
						...documents.byId,
						[payload.documentId.toUpperCase()]: payload
					},
					allIds: [...documents.allIds, payload.documentId.toUpperCase()]
				};

				newState = {
					...state,
					documents: documents
				};
			}

			break;
		}
		case actions.SET_CHANGE_REASON_REQUIRED: {
			newState = {
				...state,
				isChangeReasonRequired:
					action.isChangeReasonRequired !== undefined ? action.isChangeReasonRequired : state.isChangeReasonRequired,
				showChangeReasonModal: action.showChangeReasonModal,
				parentName: action.parentName
			};

			break;
		}
		case actions.SHOW_CHANGE_REASON_MODAL: {
			const documentId = action.documentId;

			const result = {
				...state,
				showChangeReasonModal: action.showChangeReasonModal,
				uploadDocumentId: action.showChangeReasonModal ? documentId : null
			};

			// The user has entered a change reason. Remove the documentId from the store.
			if (!action.showChangeReasonModal && documentId) {
				result.documents = {
					byId: {
						...result.documents.byId
					},
					allIds: state.documents.allIds.filter((id) => id !== documentId)
				};
				delete result.documents.byId[documentId];
			}

			return result;
		}
		/* ******************************* Document helper actions ******************************** */
		// case actions.DOCHELPER_UPLOAD_DOCUMENT:
		// case actions.DOCUMENT_UPLOAD_PROGRESS:
		// case 'DOCUMENT_UPLOAD_COMPLETE':
		case actions.DOCUMENT_DOWNLOAD_PROGRESS: {
			if (action.meta.docHelper.message) {
				let documentId = action.meta.docHelper.message.FileId;
				let version = action.meta.docHelper.message.FileVersion;

				let documents = initializeDocuments(state);

				documents = {
					byId: {
						...documents.byId,
						[documentId.toUpperCase()]: {...documents.byId[documentId.toUpperCase()], versionNumber: version}
					},
					allIds: [...documents.allIds]
				};

				newState = {
					...state,
					documents: documents
				};
			}

			break;
		}
		// case 'DOCUMENT_DOWNLOAD_COMPLETE':
		// case 'API_ERROR': {
		// 	console.log('❂❂❂❂❂❂ 440GL dochelper action: ', action);

		// 	break;
		// }

		default:
			return state;
	}

	return newState ? newState : state;
}

function initializeDocuments(state) {
	let documents;
	if (state.documents) {
		documents = {
			byId: {...state.documents.byId},
			allIds: [...state.documents.allIds]
		};
	} else {
		documents = Utility.normalize();
	}
	return documents;
}
